import SearchTab, { Pagination } from '@/components/SeachTab';
import { useKnowledgeHubStore } from './store/useKnowledgeHubStore';
import { getAuthors } from '@/services/knowledge-hub/utils';
import Card from '@/components/Card';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import { ResourceEntity } from '@/graphql/generated/graphql';
import { useEffect, useState } from 'react';
import { SearchTabFilters, fetchResourcePageable } from '@/services/knowledge-hub/resource.service';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export default function SearchTabKnowledgeHub() {
  const { page: knowledgeHubPage } = useKnowledgeHubStore();
  const [resources, setResources] = useState<ResourceEntity[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageable, setPageable] = useState<Pagination | undefined>();
  const [filters, setFilters] = useState<SearchTabFilters>({});

  useEffect(() => {
    (async () => {
      const response = await fetchResourcePageable(page, filters);
      setResources(response.resources);
      setPageable(response.pagination);
    })();
  }, [page, filters]);

  return (
    <SearchTab
      data={resources}
      searchSection={knowledgeHubPage.page?.searchSection}
      pageable={pageable}
      onChangePage={(page) => setPage(page)}
      onChangeFilters={(filters) => setFilters(filters)}>
      {resources?.map((resource: ResourceEntity) => {
        return (
          <AnimatedFadeInComponent key={resource!.id!}>
            <Card
              key={resource.id}
              title={resource.attributes?.title || ''}
              description={resource.attributes?.briefDescription || ''}
              author={getAuthors(resource)}
              link={`/knowledge-hub/slug/${resource.attributes?.slug}`}
              tags={
                <DefaultContentTemplateTags
                  tags={[resource?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
                  className="!my-2"
                />
              }
              image={{
                url: resource.attributes?.cover.data?.attributes?.url || '',
                alternativeText: resource.attributes?.cover.data?.attributes?.alternativeText || '',
              }}
            />
          </AnimatedFadeInComponent>
        );
      })}
    </SearchTab>
  );
}
